import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// Legacy /login route — redirects to home and opens the sign-in dialog.
// Kept so old deep-links, ProtectedRoute redirects and email links continue to work.
export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { openAuth, user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate(user.role === "admin" ? "/admin" : "/account", { replace: true });
      return;
    }
    const redirectTo = location.state?.from?.pathname || "/";
    openAuth();
    navigate(redirectTo, { replace: true });
  }, [navigate, location, openAuth, user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F2ED] text-[#5C574F] text-sm">
      Opening sign-in…
    </div>
  );
}
